import React, { useState } from "react";
import NavigationBar from "../../components/NavBar/Navbar";
import Cookie from "../../components/Cookie/Cookie";
import "./Careers.css";
import FNLogo from "../../assets/fnLogo.webp";
import { Card, Row, Col } from "react-bootstrap";
import careersData from "./Careers.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faBriefcase } from "@fortawesome/free-solid-svg-icons";
import Footer from "../../components/Footer/Footer";
import ExploreModal from "./ExploreModal/Explore";
 
function Careers() {
    const [careers] = useState(careersData["why-us-cards"]);

    const fitInCards = careersData["fit-in-cards"];
    const [flippedCard, setFlippedCard] = useState(null);

    const handleCardClick = (index) => {
        // If the clicked card is already flipped, toggle it back to normal
        setFlippedCard(flippedCard === index ? null : index);
    };

    const exploreCards = careersData["explore-cards"];

    const [selectedJob, setSelectedJob] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const handleShow = (job) => {
        setSelectedJob(job);
        setShowModal(true);
      };
    
      const handleClose = () => {
        setShowModal(false);
      };

    return (
        <div className="career-container">
            <Cookie />
            <NavigationBar />

            <section className="career-hero-body" id="about-body">
                <div className="career-hero-text">
                    <div className="title-text">
                        <h1>
                            Join <span className="fn-name">FusionNode</span> — Where Innovation, Technology, and Talent Come Together
                        </h1>
                    </div>
                    <div className="subTitle-text">
                        <p>
                            Be part of a company at the forefront of cybersecurity, AI, and workforce development. We're redefining how businesses scale and stay secure in a digital-first world.
                        </p>
                        <button className="explore-btn" onClick={() => window.location.href = "#explore"}>Explore Open Roles</button>
                    </div>
                </div>
            </section>

            <section className="fn-definition">
                <div className="fn-def-content">
                    <img src={FNLogo} alt="FusionNode Logo" className="fn-logo" />
                    <h1 className="future-text mb-3">
                        Your Future Begins at <span className="fn-name">FusionNode</span>
                    </h1>
                    <p className="fn-msp">
                        FusionNode is a cybersecurity-first company helping global businesses scale securely. As both a Managed Service Provider (MSP) and an Employer of Record (EOR), we deliver strategic security services, tech talent development, and workforce solutions across the globe.
                    </p>
                    <p className="fn-msp">
                        Our mission is simple: Fuse innovation, technology, and talent to solve the world's most complex cyber challenges.
                    </p>
                </div>
            </section>

            <section className="why-section">
                <div className="why-div">
                    <h1 className="why-title">
                        Why Work With <span className="fn-name">Us?</span>
                    </h1>

                    <div className="cards-section">
                        <Row className="d-flex justify-content-center">
                            {careers.map((career) => {
                                const isEven = parseInt(career["card-number"], 10) % 2 === 0;
                                const cardBgClass = isEven ? "bg-navy" : "bg-blue";

                                return (
                                    <Col key={career.id} 
                                    xs={8}
                                    md={6}
                                    lg={4} className="mb-5 d-flex justify-content-center">
                                        <Card className={`why-cards ${cardBgClass}`}>
                                            <Card.Body>
                                                <h5 className="card-career-title mb-3">{career["card-title"]}</h5>
                                                <p className="card-desc mb-5">{career["card-description"]}</p>
                                                <h6 className="card-num">{career["card-number"]}</h6>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                );
                            })}
                        </Row>
                    </div>
                </div>
            </section>

            <section className="fit-in-section">
                <div className="fit-in-div">
                    <h1 className="fit-title">Where <span className="fn-name">You</span> Fit In</h1>
                    <div className="fit-card-section">
                        <Row className="d-flex justify-content-center">
                            {fitInCards.map((card, index) => {
                                // Use the color from the JSON data
                                const cardColorClass = card.color;
                                const isFlipped = flippedCard === index;

                                return (
                                    <Col
                                        key={index}
                                        xs={8}
                                        md={6}
                                        lg={4}
                                        className="d-flex mb-5 justify-content-center"
                                        onClick={() => handleCardClick(index)} // Handle click here
                                    >
                                        <div className={`fit-card-container ${isFlipped ? "flipped" : ""}`}>
                                            <div className={`fit-card fit-card-front ${cardColorClass}`}>
                                                <h5 className="fit-card-title">{card["card-title"]}</h5>
                                            </div>
                                            <div className={`fit-card fit-card-back ${cardColorClass}`}>
                                                <h5 className="fit-card-title">{card["card-title"]}</h5>
                                                <p className="fit-card-description">{card["card-description"]}</p> 
                                            </div>
                                        </div>
                                    </Col>
                                );
                            })}
                        </Row>
                    </div>
                </div>
            </section>

            <section className="explore-section" id="explore">
                <div className="explore-div">
                    <h1 className="explore-title">
                    Explore Open <span className="fn-name">Positions</span>
                    </h1>
                    <div className="explore-cards-container">
                    <Row className="explore-col d-flex justify-content-center">
                        {exploreCards.map((card, index) => (
                        <Col
                            key={index}
                            xs={6}
                            sm={8}
                            md={8}
                            lg={10}
                            className=" d-flex mb-5 justify-content-center"
                        >
                            <Card className="explore-card">
                            <div className="left-content">
                                <h5 className="explore-card-title">{card.position}</h5>
                                <div className="bottom-content">
                                <p className="explore-card-location">
                                    <FontAwesomeIcon icon={faLocationDot} className="card-icon" />
                                    {card.location}
                                </p>
                                <p className="explore-card-mode">
                                    <FontAwesomeIcon icon={faBriefcase} className="card-icon" />
                                    {card.mode}
                                </p>
                                </div>
                            </div>
                            <div className="right-content">
                                <button
                                className="see-details-btn"
                                onClick={() => handleShow(card)}
                                >
                                See Details
                                </button>
                            </div>
                            </Card>
                        </Col>
                        ))}
                    </Row>
                    </div>
                </div>
                </section>

            {/* <section className="says-section">
                <div className="says-div">
                    <h1 className="text-light">What Our <span className="fn-name">Team</span> Says</h1>
                    <div className="says-cards-container">
                        <Card>Card 1</Card>
                    </div>
                </div>
            </section> */}

            {/*<section className="build-section">
                <div className="build-div">
                    <h1>Let's Build the Future <span className="fn-name">Together</span></h1>
                    <Card className="ready-card">
                        <h1>Ready to Apply?</h1>
                        <p>Submit the form and attach your resume—it only takes a few minutes.</p>
                        <button className="ready-btn" onClick={() => window.location.href = "#explore"}>View Open Roles</button>
                    </Card>
                </div>
            </section>*/}

            <section className="talent-section">
                <div className="talent-div">
                    <h1 className="talent-title">We're Always Looking for <span className="fn-name">Exceptional</span> Talent</h1>
                    <i>If you're passionate about cybersecurity, tech, or workforce<br/>innovation but don't see the right fit, send us your resume—we'd<br/>still love to meet you.</i>
                    <button className="talent-btn">Submit Your Resume</button>
                </div>
            </section>

            
            <Footer />
            {selectedJob && (
                <ExploreModal show={showModal} onHide={handleClose} job={selectedJob} onClose={handleClose}/>
            )}
        </div>
    );
}

export default Careers;
